import useSWR from "swr";
import { type MyQuiz } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/quizzes/me";

export function useMyQuizzes() {
  return useSWR<MyQuiz[], Error>(url, simpleFetcher);
}
